export default {"src":"/_next/static/media/clock-solid.127c8419.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};